const ADMIN_EMAILS = [
    "naru@stax.ai", 
    "cam@stax.ai", 
    "kyle@stax.ai",
    "dlee@stax.ai", 
]

export {
    ADMIN_EMAILS, 
}